import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import styles from './Collections.scss'
import {CollectionCard} from './CollectionCard'
import {collectionsMessages} from './intlMessages'
import * as userActions from 'lib/api/currentUser'
import {showModal} from 'lib/modalUtils'
import {promiseMapAll} from 'lib/utils'
import {Msg, featureNames} from 'lib/localization'
import {collectionActions, collectionSelectors} from 'data/resources/collections'
import {Card} from 'common/styleguide/Card'
import {CTA} from 'common/styleguide/CTA'
import {RadioGroup} from 'common/styleguide/RadioGroup'
import popoverMenuStyles from 'common/styleguide/PopoverMenu/PopoverMenu.scss'
import {CREATE_EDIT_COLLECTION_DIALOG} from 'common/modals/CreateEditCollection'
import {withCollapseState} from 'common/layouts/SideNavLayout/SideNavContexts'
import {PopoverFilter} from 'common/PopoverFilter'
import {IeNudgeBar} from 'common/IeNudgeBar'
import {Loadable} from 'common/Loadable'
import {OrderedMap} from 'immutable'
import Helmet from 'react-helmet'
import {FormattedMessage as T, injectIntl} from 'react-intl'
import cx from 'classnames'

const ownershipFilterOpts = OrderedMap({
  all: <T id='Collections.allCollections' defaultMessage='All Collections' />,
  yours: <T id='Collections.yourCollections' defaultMessage='Yours' />,
  followed: <T id='Collections.followedCollections' defaultMessage='Followed' />
})

const filterCollections = (collections, ownership, cuid) => {
  switch (ownership) {
    case 'yours':
      return collections.filter(c => c.userId === cuid)
    case 'followed':
      return collections.filter(c => c.userId !== cuid)
    default:
      return collections
  }
}

class _Collections extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      ownership: 'all'
    }
  }

  onOwnershipChange = (ownership) => {
    this.setState({ownership})
  }

  render () {
    const {
      collections,
      currentUser,
      setPreference,
      intl,
      collapseState
    } = this.props
    const {
      ownership
    } = this.state
    const filteredCollections = filterCollections(collections, ownership, currentUser.id)
    const disableFilter = !collections.find(c => c.userId !== currentUser.id)
    const isMobile = collapseState === 'viewport'

    return (
      <Fragment>
        <Helmet title={`${intl.formatMessage(featureNames.collections)} · Ride with GPS `} />
        <IeNudgeBar currentUser={currentUser} setPreference={setPreference} />
        <div className={cx(styles.wrap, isMobile && styles.collapsed)}>
          {collections.size > 0 ? <Fragment>
            <h2 className={styles.collectionsHeader} data-heading-alt><Msg m={featureNames.collections} /></h2>
            <div className={cx(styles.collectionsTools, isMobile && styles.collapsed)}>
              <PopoverFilter
                hidePopoverLabel
                disabled={disableFilter}
                label={ownershipFilterOpts.get(ownership)}
                className={styles.ownershipPopover}>
                <ul className={popoverMenuStyles.PopoverMenu}>
                  <RadioGroup
                    style={{margin: '0 0'}}
                    horizontal
                    options={ownershipFilterOpts}
                    selected={ownership}
                    radioClass={styles.radioClass}
                    onChange={this.onOwnershipChange} />
                </ul>
              </PopoverFilter>
              <CTA
                secondary
                margins={false}
                className={styles.newCTA}
                onClick={() => showModal(CREATE_EDIT_COLLECTION_DIALOG, {
                  modalTitle: intl.formatMessage(collectionsMessages.newCollection)
                })}>
                {intl.formatMessage(collectionsMessages.newCollection)}
              </CTA>
            </div>
            <div className={cx(styles.collectionCards, isMobile && styles.collapsed)}>
              {filteredCollections.toIndexedSeq().map(c => <CollectionCard key={c.id} collection={c} isMobile={isMobile} />)}
            </div>
          </Fragment>
            : <NoCollections {...this.props} />}
        </div>
      </Fragment>
    )
  }
}

const NoCollections = ({intl}) => (
  <div className={styles.empty}>
    <h2 data-heading-alt>
      <T id='Collections.emptyHeader' defaultMessage='Welcome to Collections' />
    </h2>
    <div className={styles.top}>
      <h2>
        <T id='Collections.emptyTop' defaultMessage='lorem for now' />
      </h2>
    </div>
    <Card noPadding className={styles.emptyCard} onClick={() => showModal(CREATE_EDIT_COLLECTION_DIALOG, {
      modalTitle: intl.formatMessage(collectionsMessages.newCollection)
    })}>
      <div className={styles.emptyCardTop}>
        <T id='Collections.emptyCardTop' defaultMessage='Create Collection' />
      </div>
      <div className={styles.emptyCardBottom}>
        <T
          id='Collections.emptyCardBottom'
          defaultMessage='Collections are the best way to organize your routes and rides, and to share them with others.' />
      </div>
    </Card>
  </div>
)

const Collections = withCollapseState(_Collections)
export const I18nCollections = injectIntl(Collections) // export for tests

const loadInitialResources = ({loadCollections}) => {
  return promiseMapAll({
    _: loadCollections()
  })
}

const LoadableCollections = (props) => {
  return <Loadable
    {...props}
    component={I18nCollections}
    loadingText={<T id='Collections.loadableText' defaultMessage='Loading your collections' />}
    resourceLoaded={() => loadInitialResources(props)} />
}

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  collections: collectionSelectors.allForUser(state)
})

const mapDispatchToProps = {
  setPreference: userActions.setPreference,
  loadCollections: collectionActions.list
}

export const CollectionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableCollections)
